import React from "react"

import { TooltipComponent } from '@syncfusion/ej2-react-popups'

/**
 * A React component to display line processing information
 * values: 数组：按顺序组织，内容为对象:
 * [
 * {
 * text: 'Step 1',
 * color: 'blank',  // 默认为 'blank' 则为空心圏，否则为实心圏。'blank'时则颜色为 #646464
 * size: '
 * },
 * ...
 * ]
 * 
 * styles: 数组：按层级，[
 * { 
 * 	color: 'blue' 
 * }, 
 * ...
 * ]
 */
const LineProcessing2 = ({ value, styles = {} }) => {
	const glyphs = '●○'

	// 子项集渲染
	const renderSubItems = (subItems, level, defaultGlyph, defaultStyle) => {
		return <div className="t-tooltip-lineprocessing2-subitems">
			{
				subItems.map((sv, si) => {
					const { text, color, glyph: itemGlyph, subItems: ssItems } = sv || {}
					const glyph = itemGlyph !== undefined ? itemGlyph : defaultGlyph
					const style = { ...defaultStyle }
					color && (style.color = color)
					return <div key={si} className="t-tooltip-lineprocessing2-subItem" style={style}>
						<div className="t-tooltip-lineprocessing2-subItem-glyph">{text}</div>
						{ssItems?.length ? renderSubItems(ssItems, level + 1, glyph, style) : null}
					</div>
				})
			}
		</div>
	}

	const tooltipTemplate = () => {
		return <div className="t-tooltip-lineprocessing2">
			{
				value.map((v, i) => {
					const { text, color = '#646464', glyph = 0, subItems } = v || {}
					const style = {}
					if (styles && styles[i]) {
						Object.assign(style, styles[i])
					}
					style.color = style.color || color
					return <div key={i} className="t-tooltip-lineprocessing2-item" style={{ marginBottom: '4px' }}>
						<div className="t-tooltip-lineprocessing2-glyph" style={style} >{glyphs[glyph] || glyphs[0]}&nbsp;{text}</div>
						{subItems?.length ? renderSubItems(subItems, 1, glyph, style) : null}
					</div>
				})
			}
		</div>
	}

	return value?.length > 0
		? <
			TooltipComponent content={tooltipTemplate} cssClass='t-tooltip-wrap-lineprocessing2'
		// opensOn="Click"
		// position='TopCenter' mouseTrail={true} showTipPointer={false}
		>
			<div className="t-lineprocessing2">
				{
					value.map((v, i) => {
						const { text, color = '#646464', glyph = 0 } = v || {}
						const style = {}
						if (styles && styles[i]) {
							Object.assign(style, styles[i])
						}
						style.color = style.color || color
						return <div key={i} className="t-lineprocessing2-glyph" style={style} >{glyphs[glyph] || glyphs[0]}</div>
					})
				}
			</div></TooltipComponent >
		: null
}

export default LineProcessing2